<template>
  <nav class="navbar navbar-dark navbar-expand-xs bg-dark" style="margin-left: -15px; margin-right: -15px;">    
    <span class="navbar-brand mb-0 h1">
      <img src="@/assets/logo.png" style="width: 40px;">
      MOZYS Monitoring Dashboard
      <span class="small text-secondary">{{ version }}</span>
    </span>
    <mz-controls></mz-controls>
  </nav>
</template>

<script>
import Controls from '@/components/Controls'

import { mapGetters } from 'vuex'

export default {
  name: 'navbar',
  computed: {
    ...mapGetters(['version'])
  },
  components: {
    mzControls: Controls
  }
}
</script>

<style>
.small {
  font-size: 0.75rem;
}
</style>




// WEBPACK FOOTER //
// src/components/Navbar.vue